import React from 'react';
import { createComponent, Panel, PropTypes } from 'console-kit';
import { MADCAP_ARTICLES } from '../../../../../../common/tools/madcapFlare/constant';

const DesignerHelpSection = createComponent({
  displayName: 'designerHelpSection',
  propTypes:   {
    token: PropTypes.shape({
      required: PropTypes.array,
      known:    PropTypes.array,
      unknown:  PropTypes.array,
      list:     PropTypes.array,
    }).isRequired,
  },
  lifecycles: {
    shouldComponentUpdate(nextProps) {
      return !_.isEqual(this.props, nextProps);
    },
  },
  render(props) {
    const _formTokens = props.token.list.map((token, key) => {
      const substring = 'form.';
      if (token.includes(substring)) {
        return <div key={key}>{`\${${token}}`}</div>;
      }
    });

    const _commonTokens = props.token.list.map((token, key) => {
      const substring = 'form.';
      if (!token.includes(substring)) {
        return <div key={key}>{`\${${token}}`}</div>;
      }
    });

    return (
      <div>
        <Panel header="Designer Help" hasBorder>
          <div>
            <p>We provide a basic template that you can use “as-is” or customize to meet your requirements.</p>
            <p>
              When making formatting and layout changes, we recommend testing your email across common email clients and
              web-based email services as there can be quite a difference in how the same email is displayed. To help
              you do this, go to the “Test” tab and enter an email address to send a test email to. When you send a test
              email, we’ll use your latest changes… there is no need to save your changes first.
            </p>

            <p>
              Within the email header fields and the email body, you can use special ‘tokens’ that are dynamically
              replaced with their real-world values at the time the email is sent.
            </p>
          </div>
        </Panel>

        <Panel header="Common tokens" hasBorder>
          <div>
            <p>
              Further descriptions of these fields can be found on the{' '}
              <a href="#" onClick={() => loadMadCapFlare(MADCAP_ARTICLES.UNDERSTANDING_EMAIL_NOTIFICATION_TOKENS)}>
                knowledgebase
              </a>
              .
            </p>
            {_commonTokens}
          </div>
        </Panel>

        <Panel header="Field tokens" hasBorder={false}>
          <div>
            <p>
              These tokens are derived from your chosen form. They will be replaced by the data the user entered into
              the field.
            </p>
            {_formTokens}
          </div>
        </Panel>
      </div>
    );
  },
});

export default DesignerHelpSection;
